// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyTitleViewer_container__6yJZ8","policyTitleContainer":"PolicyTitleViewer_policyTitleContainer__KXDMH","icon":"PolicyTitleViewer_icon__cC2Cj"};